export const SML_FIRST_YEAR = "Sml50OneTimeOffer";
export const SML_FOREVER = "SmlHalfOffForever";
